module.exports = __webpack_public_path__ + "static/media/curves_and_colors_100.4cec5a4b.ico";